import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Chatroom } from '../components/Chatroom';
import { fetchLatestChatroomForOrder, openChatroom, sendMessage } from '../lib/chat';
import { getTokenFromLocalStorage } from '../lib/local-storage';
import { useOrders } from '../store/orders';
import useUser from '../store/user';

const OrderSupportPage = () => {
	const [loading, setLoading] = useState(true);
	const [chatroomKey, setChatroomKey] = useState<string | null>(null);
	const [token, setToken] = useState<string | null>(null);
	const { user } = useUser();
	const params = useParams();
	const [createView, setCreateView] = useState(false);
	const [initialMessage, setInitialMessage] = useState('');
	const [isSending, setIsSending] = useState(false);

	const orderKey = params.orderKey;

	const loadChat = async () => {
		try {
			const existingChatroom = await fetchLatestChatroomForOrder(orderKey as string);

			if (existingChatroom) {
				setChatroomKey(existingChatroom.chatroomKey);
			} else {
				setCreateView(true);
			}
		} catch (err) {
			console.error(err);
			alert('Could not load a support chat.');
		} finally {
			setLoading(false);
		}
	};

	const onSendFirstMessage = async () => {
		if (isSending) {
			return;
		}

		const { orders } = useOrders.getState();

		setIsSending(true);

		const order = orders[orderKey as string];

		let chatTitle = 'Chat with Relay';

		if (order?.consumer?.name) {
			chatTitle = `Order for ${order.consumer.name}`;
		}

		try {
			const newChatroom = await openChatroom(orderKey as string, chatTitle);

			if (newChatroom?.chatroomKey) {
				const isSuccess = await sendMessage(newChatroom.chatroomKey, initialMessage);

				if (isSuccess) {
					setInitialMessage('');
					setChatroomKey(newChatroom.chatroomKey);
					setCreateView(false);
				} else {
					throw new Error('Could not send the message. Try again.');
				}
			} else {
				throw new Error(`Could not create chatroom`);
			}
		} catch (err) {
			// setChatroomKey("ERROR");
		}

		setIsSending(false);
	};

	useEffect(() => {
		const token = getTokenFromLocalStorage();
		setToken(token);
		loadChat();
	}, [orderKey]);

	return loading || !token ? (
		<p className="p-2">One moment...</p>
	) : createView ? (
		<div className="mx-auto my-10 text-center max-w-4xl">
			<p className="font-semibold text-3xl text-gray-800 mb-2">Order Support</p>
			<p className="text-gray-700 mb-4">Type a message to open a chatroom with Relay</p>
			<div className="flex flex-col gap-2 p-2 md:flex-row justify-center">
				<input
					type="text"
					placeholder="Type a message..."
					className="border border-gray-300 rounded-md px-4 py-2 md:w-96"
					value={initialMessage}
					disabled={isSending}
					onChange={(e) => setInitialMessage(e.target.value)}
				/>
				<button
					onClick={onSendFirstMessage}
					disabled={isSending}
					className="bg-blue-700 hover:bg-blue-800 px-4 py-2 text-white rounded-sm"
				>
					Send
				</button>
			</div>
		</div>
	) : (
		<Chatroom token={token} user={user} chatroomKey={chatroomKey} orderKey={orderKey} />
	);
};

export default OrderSupportPage;
